import React, { useState, useEffect } from 'react';

import { IComponentDate } from '../../component.d';
import { RenderRequired } from './Form';
import moment from 'moment';

const AllForFormInput = function(props: IComponentDate) {
  const { field, align, width, onChange, required, label, type } = props;

  const [data, setData] = useState('');

  return (
    <div className="all-for-date">
      <div
        className="weui-cells__group weui-cells__group_form"
        style={{ width: `${width}%` }}
      >
        <div className="weui-cells">
          <div
            className="weui-cell weui-cell_active weui-cell_access"
            onClick={() => {
              window.weui!.datePicker({
                start: 1900,
                end: new Date().getFullYear(),
                onChange: (result: any) => {
                  // console.log(`change`, result);
                },
                onConfirm: (result: any) => {
                  let date = new Date();
                  date.setFullYear(result[0].value);
                  date.setMonth(result[1].value - 1);
                  date.setDate(result[2].value);

                  let format = moment(date).format('YYYY-MM-DD');
                  setData(format);
                  onChange(type, field, format);
                },
                title: field
              });
            }}
          >
            <div className="weui-cell__bd">
              {field} {RenderRequired(required)}
            </div>
            <div className="weui-cell__ft">{data}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllForFormInput;
